import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageAnnecy: React.FC = () => (
  <LocalSeoPage
    city="Annecy"
    slug="depannage-informatique-annecy"
    metaTitle="Dépannage Informatique Annecy | Réparation PC | SOS IT"
    metaDescription="Technicien informatique à Annecy. Dépannage ordinateur, virus, Windows bloqué. Intervention rapide à domicile. Diagnostic gratuit."
    intro="Vous êtes à Annecy et votre ordinateur vous cause des ennuis ? Que ce soit un PC qui démarre plus, un virus tenace ou une connexion WiFi capricieuse, notre technicien intervient rapidement à domicile ou à distance. Diagnostic gratuit, sans engagement, et un devis clair avant de commencer."
    postalCode="74000"
    nearbyTowns={[
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Cran-Gevrier' },
      { name: 'Seynod' },
      { name: 'Meythet' },
      { name: 'Poisy' },
      { name: 'Pringy' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageAnnecy;
